<!-- ═══════════════ PREMIUM LUXURY FOOTER ═══════════════ -->
<footer class="border-t border-border-primary bg-black/45 mt-4 relative z-10">
  <div class="max-w-[1320px] mx-auto px-6 lg:px-10 py-4">
    <div class="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">

      <!-- Brand Details -->
      <div class="col-span-2 flex flex-col gap-4">
        <div class="flex items-center gap-2.5 cursor-pointer select-none" (click)="goHome()">
          <img src="/logo.png" alt="DEX" class="h-6 w-auto max-h-[24px] object-contain shrink-0" />
          <span class="font-display font-black text-[22px] leading-none text-white tracking-widest translate-y-[0.5px]">DEX</span>
        </div>
        <p class="text-text-muted text-[13.5px] max-w-[270px] leading-relaxed">
          {{ state.homeCms().footer.description }}
        </p>
        <!-- Social Icons -->
        <div class="flex items-center gap-3.5 mt-2">
          <a [href]="state.siteSettings().xUrl || '#'" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Twitter">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
          <a [href]="state.siteSettings().telegramUrl || '#'" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Telegram">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
            </svg>
          </a>
          <a [href]="state.siteSettings().discordUrl || '#'" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Discord">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
            </svg>
          </a>
          <a [href]="state.siteSettings().youtubeUrl || 'https://youtube.com'" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="YouTube">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.163a3.003 3.003 0 0 0-2.11-2.11C19.517 3.545 12 3.545 12 3.545s-7.517 0-9.388.508a3.003 3.003 0 0 0-2.11 2.11C0 8.033 0 12 0 12s0 3.967.502 5.837a3.003 3.003 0 0 0 2.11 2.11c1.871.508 9.388.508 9.388.508s7.517 0 9.388-.508a3.003 3.003 0 0 0 2.11-2.11C24 15.967 24 12 24 12s0-3.967-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>

        </div>
      </div>

      <!-- Products Footer -->
      <div>
        <h5 class="text-[11px] uppercase font-black tracking-widest text-white mb-4">Products</h5>
        @for (item of state.footerProducts; track item.id) {
        <a (click)="state.selectFooterProduct(item.id)" class="footer-link block mb-2.5">{{ item.label }}</a>
        }
      </div>

      <!-- Company Footer -->
      <div>
        <h5 class="text-[11px] uppercase font-black tracking-widest text-white mb-4">Company</h5>
        @for (item of state.footerCompany; track item.id) {
        <a (click)="state.selectFooterCompany(item.id)" class="footer-link block mb-2.5">{{ item.label }}</a>
        }
      </div>

      <!-- Community Footer -->
      <div>
        <h5 class="text-[11px] uppercase font-black tracking-widest text-white mb-4">Community</h5>
        @for (item of state.footerCommunity(); track item.label) {
        <a [href]="item.url || '#'" target="_blank" rel="noopener noreferrer" class="footer-link block mb-2.5">{{ item.label }}</a>
        }
      </div>

    </div>

    <!-- Bottom Bar with Theme toggles -->
    <div data-engine="thecryptoape"
      class="pt-6 border-t border-border-primary flex flex-col md:flex-row justify-between items-center gap-4 text-[12.5px] text-text-dim font-medium">
      <p>© 2026 DEX. All rights reserved.</p>
      <!-- Powered by thecryptoape -->
      <div class="flex items-center gap-6">
        @for (item of state.footerLegal; track item.id) {
          <a (click)="state.selectFooterLegal(item.id)" class="hover:text-gold cursor-pointer transition-colors footer-link">
            {{ item.label }}
          </a>
        }
      </div>
    </div>
  </div>
</footer>